import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import { Link } from "react-router-dom";
import {
	displayError,
	displaySuccess,
	getExpenses,
} from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import config from "../config/config";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { Modal } from "react-bootstrap";
import { getUserData } from "../actions/userdata";
import "../Gynac/style.css";

const statusClass = (status) => {
	const s = (status || '').toLowerCase();
	if (s === 'paid' || s === 'approved') return 'status-pill status-approved';
	if (s === 'rejected') return 'status-pill status-rejected';
	return 'status-pill status-pending';
};

const Expenses = (props) => {
	const [users, setUsers] = useState([]);
	const [count, setCount] = useState(10);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(0);
	const [search, setSearch] = useState("");
	const [sort, setSort] = useState("");
	const [sortOrder, setSortOrder] = useState("");
	const [statusModal, setStatusModal] = useState(false);
	const [selectedExpense, setSelectedExpense] = useState(null);
	const [deleteModal, setDeleteModal] = useState(false);
	const [expenseToDelete, setExpenseToDelete] = useState(null);
	const [summary, setSummary] = useState({
		total_amount: 0,
		total_count: 0,
		paid_amount: 0,
		paid_count: 0,
		pending_amount: 0,
		pending_count: 0,
		rejected_amount: 0,
		rejected_count: 0,
	});

	const getList = async (perPage = count, pageOverride = 1, searchValue = search, sortValue = sort, orderby = sortOrder) => {
		props.toggleLoader(true);
		const res = await getExpenses(perPage, pageOverride, searchValue, sortValue, orderby);
		const totalCount = res?.metadata?.total_count || 0;
		const computedTotalPage = res?.metadata?.totalPage
			|| (perPage > 0 ? Math.ceil(totalCount / perPage) : 0);
		setTotal(computedTotalPage);
		setPage(res?.metadata?.page || pageOverride);
		setUsers(res?.data || []);
		setSummary({
			total_amount: res?.metadata?.total_amount || 0,
			total_count: res?.metadata?.total_count || 0,
			paid_amount: res?.metadata?.paid_amount || 0,
			paid_count: res?.metadata?.paid_count || 0,
			pending_amount: res?.metadata?.pending_amount || 0,
			pending_count: res?.metadata?.pending_count || 0,
			rejected_amount: res?.metadata?.rejected_amount || 0,
			rejected_count: res?.metadata?.rejected_count || 0,
		});
		props.toggleLoader(false);
	};
	useEffect(() => {
		getList(count, 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const handle = setTimeout(() => {
			getList(count, 1, search, sort, sortOrder);
		}, 400);
		return () => clearTimeout(handle);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search, sort, sortOrder]);

	const handlePageClick = async (e) => {
		const selectedPage = e.selected + 1;
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
		getList(count, selectedPage, search, sort, sortOrder);
	};

	const handlePerPageChange = (e) => {
		const next = parseInt(e.target.value, 10);
		setCount(next);
		getList(next, 1, search, sort, sortOrder);
	};

	const openStatusModal = (expense) => {
		setSelectedExpense(expense);
		setStatusModal(true);
	};

	const changeStatus = async (status) => {
		try {
			const token = localStorage.getItem("token");
			props.toggleLoader(true);
			await axios.put(`${config.siteUrl}/expenses/${selectedExpense._id}`,
				{ status },
				{ headers: { Authorization: `Bearer ${token}` } }
			);
			displaySuccess(`Expense ${status} successfully`);
			setStatusModal(false);
			setSelectedExpense(null);
			await getList(count, page, search, sort, sortOrder);
		} catch (err) {
			displayError(err);
		} finally {
			props.toggleLoader(false);
		}
	};

	const openDeleteModal = (expense) => {
		setExpenseToDelete(expense);
		setDeleteModal(true);
	};

	const closeDeleteModal = () => {
		setDeleteModal(false);
		setExpenseToDelete(null);
	};

	const deleteExpense = async () => {
		if (!expenseToDelete?._id) return;
		try {
			const token = localStorage.getItem("token");
			props.toggleLoader(true);
			await axios.get(`${config.siteUrl}/delete-expense/${expenseToDelete._id}`, {
				headers: { Authorization: `Bearer ${token}` },
			});
			displaySuccess("Expense deleted successfully");
			closeDeleteModal();
			await getList(count, page, search, sort, sortOrder);
		} catch (err) {
			displayError(err);
		} finally {
			props.toggleLoader(false);
		}
	};

	const stats = [
		{ label: 'Total', amount: summary.total_amount, count: summary.total_count, icon: 'fas fa-wallet', color: '#5e72e4', tint: '#E7EAFB' },
		{ label: 'Paid', amount: summary.paid_amount, count: summary.paid_count, icon: 'fas fa-check-circle', color: '#2dce89', tint: '#E0F7EC' },
		{ label: 'Pending', amount: summary.pending_amount, count: summary.pending_count, icon: 'fas fa-hourglass-half', color: '#fb6340', tint: '#FFE9E1' },
		{ label: 'Rejected', amount: summary.rejected_amount, count: summary.rejected_count, icon: 'fas fa-times-circle', color: '#f5365c', tint: '#FDE2E8' },
	];

	return (
		<div className="g-sidenav-show bg-gray-100">
			<div id="wrapper">
				<Leftbar />
				<main className="main-content border-radius-lg">
					<Topbar />

					<div className="header bg-primary pb-6">
						<div className="container-fluid">
							<div className="header-body">
								<div className="row align-items-center py-4">
									<div className="col-lg-6 col-7">
										<nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
											<ol className="breadcrumb breadcrumb-links breadcrumb-dark">
												<li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
												<li className="breadcrumb-item"><a href="#">Expenses</a></li>
											</ol>
										</nav>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="container-fluid mt--6">
						<div className="mb-3 expenses-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12 }}>
							{stats.map((stat) => (
								<div
									key={stat.label}
									style={{
										position: 'relative',
										background: '#fff',
										borderRadius: 10,
										boxShadow: '0 1px 4px rgba(50, 50, 93, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03)',
										padding: '10px 12px 10px 14px',
										overflow: 'hidden',
									}}
								>
									<div
										style={{
											position: 'absolute',
											top: 0,
											left: 0,
											width: 3,
											height: '100%',
											background: stat.color,
										}}
									/>
									<div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 4 }}>
										<span
											style={{
												fontSize: '9.5px',
												fontWeight: 700,
												color: '#8898aa',
												letterSpacing: '0.5px',
												textTransform: 'uppercase',
											}}
										>
											{stat.label}
										</span>
										<div
											style={{
												width: 26,
												height: 26,
												borderRadius: 7,
												background: stat.tint,
												color: stat.color,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												flexShrink: 0,
											}}
										>
											<i className={stat.icon} style={{ fontSize: '11px' }} />
										</div>
									</div>
									<div
										style={{
											fontSize: '16px',
											fontWeight: 800,
											color: '#32325d',
											lineHeight: 1.15,
											marginBottom: 4,
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										₹{(stat.amount || 0).toLocaleString('en-IN')}
									</div>
									<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
										<span
											style={{
												fontSize: '9.5px',
												fontWeight: 700,
												color: stat.color,
												background: stat.tint,
												padding: '1px 6px',
												borderRadius: 999,
												lineHeight: 1.4,
											}}
										>
											{stat.count || 0}
										</span>
										<span style={{ fontSize: '10px', color: '#8898aa', fontWeight: 500 }}>
											{(stat.count === 1) ? 'item' : 'items'}
										</span>
									</div>
								</div>
							))}
						</div>
					</div>

					<div className="container-fluid">
						<div className="card gynac-card">
							<div className="gynac-card-header">
								<h3 className="gynac-title">
									Expenses Listing

								</h3>

								<div className="gynac-toolbar">
									<div className="gynac-search">
										<i className="fas fa-search search-icon" />
										<input
											type="text"
											placeholder="Search title, patient, provider"
											value={search}
											onChange={(e) => setSearch(e.target.value)}
										/>
									</div>
									<div className="gynac-filter">
										<select value={sort} onChange={(e) => setSort(e.target.value)}>
											<option value="">Sort by</option>
											<option value="title">Title</option>
											<option value="patient_name">Patient</option>
											<option value="amount">Amount</option>
										</select>
									</div>
									<div className="gynac-filter">
										<select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
											<option value="">Order</option>
											<option value="asc">Ascending</option>
											<option value="desc">Descending</option>
										</select>
									</div>
								</div>
							</div>

							<div className="table-responsive">
								<table className="gynac-table">
									<colgroup>
										<col style={{ width: '21%' }} />
										<col style={{ width: '21%' }} />
										<col style={{ width: '21%' }} />
										<col style={{ width: '12%' }} />
										<col style={{ width: '17%' }} />
										<col style={{ width: '8%' }} />
									</colgroup>
									<thead>
										<tr>
											<th>Title / Category</th>
											<th>Patient</th>
											<th>Provider / Service</th>
											<th style={{ textAlign: 'right' }}>Amount</th>
											<th style={{ textAlign: 'center' }}>Status & Action</th>
											<th style={{ textAlign: 'center' }}>Action</th>
										</tr>
									</thead>
									<tbody>
										{users?.map((user) => (
											<tr key={user?._id}>
												<td data-label="Title">
													<div className="doctor-name" style={{ marginBottom: 2 }}>{user?.title || '—'}</div>
													{user?.expense_category?.name && (
														<span className="cred-education">{user.expense_category.name}</span>
													)}
												</td>
												<td data-label="Patient">
													<div className="doctor-name" style={{ marginBottom: 2 }}>{user?.patient_name || '—'}</div>
													{user?.user?.email && (
														<a href={`mailto:${user.user.email}`} className="doctor-email">{user.user.email}</a>
													)}
												</td>
												<td data-label="Provider">
													<div className="doctor-name" style={{ marginBottom: 2 }}>{user?.provider?.name || '—'}</div>
													{user?.provider?.email && (
														<a href={`mailto:${user.provider.email}`} className="doctor-email" style={{ display: 'block' }}>
															{user.provider.email}
														</a>
													)}
													{user?.service?.name && (
														<span className="cred-education">{user.service.name}</span>
													)}
												</td>
												<td data-label="Amount" style={{ textAlign: 'right' }}>
													<span style={{ fontWeight: 700, color: '#1f2540', fontSize: '1rem' }}>
														₹{(user?.amount || 0).toLocaleString('en-IN')}
													</span>
												</td>
												<td data-label="Status" style={{ textAlign: 'center' }}>
													<div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'stretch', width: 150, margin: '0 auto' }}>
														<span className={statusClass(user?.status)} style={{ textTransform: 'capitalize' }}>{user?.status || '—'}</span>
														{user?.status === 'pending' ? (
															<button className="btn-pill btn-approve" onClick={() => openStatusModal(user)}>
																Change Status
															</button>
														) : (
															<button
																className="btn-pill btn-approve"
																style={{ visibility: 'hidden' }}
																aria-hidden="true"
																tabIndex={-1}
															>
																Change Status
															</button>
														)}
													</div>
												</td>
												<td data-label="Action" style={{ textAlign: 'center' }}>
													<button
														type="button"
														title="Delete"
														aria-label="Delete expense"
														onClick={() => openDeleteModal(user)}
														style={{
															background: '#FDE2E8',
															color: '#d32f2f',
															border: 'none',
															borderRadius: '50%',
															width: 36,
															height: 36,
															display: 'inline-flex',
															alignItems: 'center',
															justifyContent: 'center',
															cursor: 'pointer',
															transition: 'background 0.15s ease',
														}}
														onMouseEnter={(e) => { e.currentTarget.style.background = '#d32f2f'; e.currentTarget.style.color = '#fff'; }}
														onMouseLeave={(e) => { e.currentTarget.style.background = '#FDE2E8'; e.currentTarget.style.color = '#d32f2f'; }}
													>
														<i className="fas fa-trash" />
													</button>
												</td>
											</tr>
										))}
										{!users?.length && (
											<tr>
												<td colSpan={6}>
													<div className="gynac-empty">
														<i className="fas fa-wallet" />
														<div className="gynac-empty-text">No expenses found</div>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>

							{users.length > 0 && (
								<div className="gynac-footer">
									<div className="gynac-per-page">
										<span>Rows per page</span>
										<select value={count} onChange={handlePerPageChange}>
											<option value={10}>10</option>
											<option value={25}>25</option>
											<option value={50}>50</option>
										</select>
									</div>
									<div className="paginate-css" style={{ margin: 0 }}>
										<ReactPaginate
											previousLabel="<"
											nextLabel=">"
											breakLabel="..."
											pageCount={total}
											forcePage={page > 0 ? page - 1 : 0}
											marginPagesDisplayed={1}
											pageRangeDisplayed={3}
											onPageChange={handlePageClick}
											containerClassName="pagination"
											activeClassName="active"
										/>
									</div>
								</div>
							)}
						</div>
					</div>

					<Modal show={statusModal} onHide={() => { setStatusModal(false); setSelectedExpense(null); }} centered>
						<Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
							<h5 className="mb-0" style={{ fontWeight: 700 }}>Change Expense Status</h5>
							<button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => { setStatusModal(false); setSelectedExpense(null); }}>&times;</button>
						</Modal.Header>
						<Modal.Body style={{ padding: '20px 24px' }}>
							<p className="mb-0">
								{selectedExpense?.title
									? <>Update status for <strong>{selectedExpense.title}</strong>. Mark as paid or reject?</>
									: 'Update status for this expense. Mark as paid or reject?'}
							</p>
						</Modal.Body>
						<Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
							<button
								className="btn"
								style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
								onClick={() => { setStatusModal(false); setSelectedExpense(null); }}
							>
								Cancel
							</button>
							<button
								className="btn"
								style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
								onClick={() => changeStatus('rejected')}
							>
								Reject
							</button>
							<button
								className="btn"
								style={{ background: '#0ca678', color: '#fff', border: '1px solid #0ca678', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
								onClick={() => changeStatus('paid')}
							>
								Paid
							</button>
						</Modal.Footer>
					</Modal>

					<Modal show={deleteModal} onHide={closeDeleteModal} centered>
						<Modal.Header style={{ borderBottom: '1px solid #f1f1f4', padding: '18px 22px', alignItems: 'center' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
								<div
									style={{
										width: 36,
										height: 36,
										borderRadius: '50%',
										background: '#FDE2E8',
										color: '#d32f2f',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										flexShrink: 0,
									}}
								>
									<i className="fas fa-exclamation-triangle" style={{ fontSize: 15 }} />
								</div>
								<h5 className="mb-0" style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1f2540' }}>Delete expense?</h5>
							</div>
							<button
								type="button"
								style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1, color: '#6b7088' }}
								onClick={closeDeleteModal}
							>
								&times;
							</button>
						</Modal.Header>
						<Modal.Body style={{ padding: '20px 22px', color: '#1f2540', fontSize: '0.95rem' }}>
							<p className="mb-0">
								Are you sure you want to delete expense{' '}
								<strong>{expenseToDelete?.title ? `"${expenseToDelete.title}"` : ''}</strong>? This action cannot be undone.
							</p>
						</Modal.Body>
						<Modal.Footer style={{ borderTop: '1px solid #f1f1f4', padding: '14px 22px' }}>
							<button
								type="button"
								style={{
									background: '#fff',
									border: '1px solid #d0d4e0',
									color: '#1f2540',
									borderRadius: 999,
									fontWeight: 600,
									padding: '8px 22px',
									cursor: 'pointer',
								}}
								onClick={closeDeleteModal}
							>
								Cancel
							</button>
							<button
								type="button"
								style={{
									background: '#d32f2f',
									color: '#fff',
									border: '1px solid #d32f2f',
									borderRadius: 999,
									fontWeight: 600,
									padding: '8px 22px',
									cursor: 'pointer',
									display: 'inline-flex',
									alignItems: 'center',
									gap: 8,
								}}
								onClick={deleteExpense}
							>
								<i className="fas fa-trash" />
								Confirm
							</button>
						</Modal.Footer>
					</Modal>
				</main>
			</div>
		</div>
	);
};

const mapDispatchToProps = { toggleLoader, getUserData };
const mapStateToProps = (state) => ({ userdata: state.userdata?.userData });
export default connect(mapStateToProps, mapDispatchToProps)(Expenses);
